import { usePatientSurgeryStore } from "../../hooks";
import { PatientSurgeryProcedureInfoCard } from "../cards";
import { PatientSurgeryResultsTable } from "../tables";

export const PatientSurgeryResultAccordion = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,
  } = usePatientSurgeryStore();

  const { procedure } = patientSurgery.data;

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  return (
    <div className="accordion" id="patientSurgeryResultAccordion">
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button
            className={`accordion-button`}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#patientSurgeryResult`}
            aria-expanded="true"
            aria-controls={`patientSurgeryResult`}
          >
            Procedimiento: {procedure.procedure.title || "Sin título"}
          </button>
        </h2>
        <div
          id={`patientSurgeryResult`}
          className={`accordion-collapse collapse show`}
          data-bs-parent="#patientSurgeryResultAccordion"
        >
          <div className="accordion-body">
            <div className="vstack gap-4">
              <PatientSurgeryProcedureInfoCard />
              <PatientSurgeryResultsTable />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
